import { render } from "./AddProfilesModal.vue?vue&type=template&id=32f03a1e"
import script from "./AddProfilesModal.vue?vue&type=script&lang=js"
export * from "./AddProfilesModal.vue?vue&type=script&lang=js"

import "./AddProfilesModal.vue?vue&type=style&index=0&id=32f03a1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__